import { render, staticRenderFns } from "./ckpnnetflow.vue?vue&type=template&id=6c54b28e&"
import script from "./ckpnnetflow.vue?vue&type=script&lang=js&"
export * from "./ckpnnetflow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports